import {
  PageContainer,
  PageHeader,
  SectionContainer,
  EntityInfoNameLine,
  // UserInfoSection,
  // EntityInfoSection,
  LabeledLine,
  HorizontalLine,
  Input,
  Text1,
  GalleryDropZone,
  Select,
  GalleryDropZoneRef,
  MediaContentDTO,
  noImageAvatar,
  Button
} from '@touche-lts/panel-ui/dist'
import { IconEmail, IconUserManagement } from 'assets/icons'
import { observer } from 'mobx-react-lite'
import { UserRoleDTO } from 'models'
import { useRef, useEffect } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'
import { AddUserPageProps } from './add-user-page.types'
import { ActionHistorySection } from 'components'
import styles from './add-user-page.module.scss'
import cl from 'classnames'
import { useGetIsResponsiveScreen } from 'hooks/custom-hooks'

const AddUserPageComponent = (props: AddUserPageProps) => {
  const {
    className,
    style,
    history: { push }
  } = props

  const {
    addUserPageStore: {
      userRequest,
      selectedUserRole,
      onUserRequestPropsChange,
      onFullNameChange,
      submit,
      validationErrors,
      onDiscardChangesClick,
      onAddUserPageMount,
      userRoleSelectOptions,
      clearStore
    },
    generalStore: {
      api: { uploadFileSigned }
    }
  } = useRootStore()

  useEffect(() => {
    onAddUserPageMount()
    return clearStore
  }, [onAddUserPageMount, clearStore])

  const gallery: GalleryDropZoneRef = useRef()

  const {isResponsive:isLaptop} = useGetIsResponsiveScreen('(max-width: 1024px)')

  const onAddUserClick = async () => {
    await gallery.current.handleImages()
    const images: MediaContentDTO[] = gallery.current.getImages()
    const imageUrl = images?.[0]?.url || ''
    onUserRequestPropsChange({ imageUrl })
    submit()
  }

  return (
    <PageContainer className={cl(styles.scrollable, className)} style={style}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: 'User management',
            iconProps: { viewBox: '0 0 22 22' },
            onClick: () => push('/user-management')
          },
          {
            label: 'Add user'
          }
        ]}
        middleContainerChildren={
          isLaptop && 
          <>
            <div className={styles.middleContainerStyle}>
              <Button preset='secondary' onClick={onDiscardChangesClick}>
                Discard
              </Button>
              <Button preset='primary' onClick={onAddUserClick}>
                Add
              </Button>
            </div>
          </>
        }
        buttons={!isLaptop ? [
          {
            children: 'Discard',
            preset: 'secondary',
            onClick: onDiscardChangesClick
          },
          { children: 'Add', preset: 'primary', onClick: onAddUserClick }
        ] : []}
      />

      <SectionContainer extraPaddingBottom>
        <EntityInfoNameLine
          editMode
          imageProps={{ src: noImageAvatar }}
          entityName={userRequest.fullName}
          nameInputProps={{
            placeholder: 'First and Last name',
            value: userRequest.fullName,
            onChange: onFullNameChange,
            errorMessage:
              validationErrors?.firstName?.[0] ||
              validationErrors?.lastName?.[0]
          }}
        />
        <LabeledLine
          innerContainerProps={{}}
          labelIcon={IconEmail}
          label='Email'
          style={{ width: '30%', marginTop: 18, marginBottom: 10 }}
        >
         {!isLaptop && <Input
            placeholder='Email'
            value={userRequest.emailAddress}
            onChange={emailAddress =>
              onUserRequestPropsChange({ emailAddress })
            }
            autoComplete='on'
            autoCapitalize='none'
            type='email'
            errorMessage={validationErrors?.emailAddress?.[0]}
          />}
        </LabeledLine>
        {isLaptop && <Input
            placeholder='Email'
            value={userRequest.emailAddress}
            onChange={emailAddress =>
              onUserRequestPropsChange({ emailAddress })
            }
            autoComplete='on'
            autoCapitalize='none'
            type='email'
            errorMessage={validationErrors?.emailAddress?.[0]}
          />}
        <HorizontalLine />
        <LabeledLine
          innerContainerProps={{}}
          label='Role'
          style={{ width: '30%', marginTop: 18, marginBottom: 10 }}
        >
          {!isLaptop && <Select<UserRoleDTO>
            placeholder='Role'
            noNoneOption
            options={userRoleSelectOptions}
            value={selectedUserRole}
            onChange={role => onUserRequestPropsChange({ role })}
            errorMessage={validationErrors?.role?.[0]}
          />}
        </LabeledLine>
        {isLaptop && <Select<UserRoleDTO>
            placeholder='Role'
            noNoneOption
            options={userRoleSelectOptions}
            value={selectedUserRole}
            onChange={role => onUserRequestPropsChange({ role })}
            errorMessage={validationErrors?.role?.[0]}
          />}
        <div style={{ display: 'flex', ...(isLaptop && {flexDirection: 'column'}) }}>
          <LabeledLine
            innerContainerProps={{}}
            label='Password'
            style={{ width: '30%', marginTop: 18, marginBottom: 10 }}
          >
            {!isLaptop && <Input
              placeholder='Password'
              value={userRequest.password}
              onChange={password => onUserRequestPropsChange({ password })}
              security='password'
              type='password'
              autoComplete='on'
              errorMessage={validationErrors?.password?.[0]}
            />}
          </LabeledLine>
            {isLaptop && <Input
              placeholder='Password'
              value={userRequest.password}
              onChange={password => onUserRequestPropsChange({ password })}
              security='password'
              type='password'
              autoComplete='on'
              errorMessage={validationErrors?.password?.[0]}
            />}
          <LabeledLine
            innerContainerProps={{}}
            label='Repeat password'
            style={{ width: '30%', marginTop: 18, marginBottom: 10, ...(!isLaptop && {marginLeft: 112}) }}
          >
            {!isLaptop && <Input
              placeholder='Repeat password'
              value={userRequest.confirmPassword}
              onChange={confirmPassword =>
                onUserRequestPropsChange({ confirmPassword })
              }
              security='password'
              type='password'
              autoComplete='password'
              errorMessage={validationErrors?.confirmPassword?.[0]}
            />}
          </LabeledLine>
            {isLaptop && <Input
              placeholder='Repeat password'
              value={userRequest.confirmPassword}
              onChange={confirmPassword =>
                onUserRequestPropsChange({ confirmPassword })
              }
              security='password'
              type='password'
              autoComplete='password'
              errorMessage={validationErrors?.confirmPassword?.[0]}
            />}
        </div>
        <HorizontalLine />
        <Text1 bold style={{ marginTop: 14 }}>
          User image
        </Text1>
        <GalleryDropZone
          uploadFile={uploadFileSigned}
          initialImages={[]}
          dropzoneOptions={{ multiple: false }}
          singleImage
          noEditing
          ref={gallery}
          style={isLaptop ? {
            display: 'flex',
            flexDirection: 'column',
            gap : 20
          } : {}}
        />
      </SectionContainer>
      {/* <UserInfoSection
        entityInfoSectionProps={{
          icons: {
            IconDeleteCircle: IconDeleteCircle,
            IconEdit: IconEdit,
            IconEditCrop: IconEditCropping,
            IconMenuDots: IconMenuDots
          },
          images: [],
          mainImage: null,
          name: '',
          setLoadingOn: () => {},
          setName: () => {},
          showError: () => {},
          uploadFile: async () => { }
        }}
      /> */}
      {/* <ActionHistorySection className={styles.sectionMarginTop} /> */} {/* For without user id doesn't work */}
    </PageContainer>
  )
}

const AddUserPage = observer(AddUserPageComponent)
export { AddUserPage }
